import { Action } from '@ngrx/store';
import { ClaimDocumentType } from './claim-document-types.reducer';

export enum ClaimDocumentTypesActionTypes {
  LOAD_DOCUMENT_TYPES = '[ClaimDocumentTypes] Load Claim Document Types',
  LOAD_DOCUMENT_TYPES_SUCCESS = '[ClaimDocumentTypes] Load Claim Document Types Success',
  LOAD_DOCUMENT_TYPES_FAIL = '[ClaimDocumentTypes] Load Claim Document Types Fail'
}

export class LoadClaimDocumentTypes implements Action {
  readonly type = ClaimDocumentTypesActionTypes.LOAD_DOCUMENT_TYPES;
}

export class LoadClaimDocumentTypesSuccess implements Action {
  readonly type = ClaimDocumentTypesActionTypes.LOAD_DOCUMENT_TYPES_SUCCESS;
  constructor(public payload: ClaimDocumentType[]) {}
}

export class LoadClaimDocumentTypesFail implements Action {
  readonly type = ClaimDocumentTypesActionTypes.LOAD_DOCUMENT_TYPES_FAIL;
  constructor(public payload: Error) {}
}

export type ClaimDocumentTypesAction =
  | LoadClaimDocumentTypes
  | LoadClaimDocumentTypesSuccess
  | LoadClaimDocumentTypesFail;

export const fromClaimDocumentTypesActions = {
  LoadClaimDocumentTypes,
  LoadClaimDocumentTypesSuccess,
  LoadClaimDocumentTypesFail
};
